// src/pages/HomePage.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import TopNav from '../components/homepage_content/TopNav';
import TopNavBar from '../components/homepage_content/TopNavBar';
import AutoScrollCarousel from '../components/AutoScrollCarousel';
import LiveMatches from '../components/homepage_content/LiveMatches';
import QuickSelection from '../components/homepage_content/QuickSelection';
import SportLists from '../components/homepage_content/SportLists';
import BetSlipFloatingButton from '../components/BetSlipFloatingButton';
import Spinner from '../components/PreLoader';
import LanguagePopup from '../components/LanguagePopup';
import { useBetSlip } from '../context/BetSlipContext';
import welcomeImage from '../assets/welcome.jpeg';
import image1 from '../assets/1.jpeg';
import image2 from '../assets/2.jpeg';

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showLanguagePopup, setShowLanguagePopup] = useState(false);
  const [showAgentModal, setShowAgentModal] = useState(true);
  const [showAgentIcon, setShowAgentIcon] = useState(false);
  const navigate = useNavigate();
  const { betslipCount } = useBetSlip();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
      const preferredLang = localStorage.getItem('preferredLanguage');
      if (!preferredLang) {
        setShowLanguagePopup(true);
      }
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const handleAgentClick = useCallback(() => {
    navigate('/agent');
  }, [navigate]);

  const handleCloseAgentModal = useCallback(() => {
    setShowAgentModal(false);
    setShowAgentIcon(true);
  }, []);

  const handleCloseLanguagePopup = useCallback(() => {
    setShowLanguagePopup(false);
  }, []);

  const handleNavigateToBetSlip = useCallback(() => {
    navigate('/betslip');
  }, [navigate]);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div className="min-h-screen bg-deep-black pt-16"> {/* Added pt-16 for fixed header */}
      {/* Language Popup */}
      {showLanguagePopup && (
        <LanguagePopup onClose={handleCloseLanguagePopup} />
      )}

      {/* Agent Modal */}
      {showAgentModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 animate-fade-in">
          <div className="relative max-w-2xl w-full mx-4">
            <button
              onClick={handleCloseAgentModal}
              className="absolute -top-3 -right-3 bg-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center z-50 hover:bg-red-600 transition-colors"
              aria-label="Close agent modal"
            >
              ×
            </button>
            <div className="relative rounded-2xl overflow-hidden border-2 border-blue-500 max-h-[80vh]">
              <div className="relative aspect-[4/5] w-full">
                <img
                  src={welcomeImage}
                  alt="World Cup 2026"
                  className="w-full h-full object-cover object-center"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 text-center">
                  <h3 className="text-2xl font-bold text-white mb-2">
                    FIFA World Cup 
                  </h3>
                  <p className="text-gray-300 mb-4">
                    USA, CANADA, MEXICO 26
                  </p>
                  <button
                    onClick={handleAgentClick}
                    className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition-colors duration-300"
                  >
                    Join Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Small Agent Icon */}
      {/* {showAgentIcon && (
        <div
          className="fixed bottom-6 left-6 z-40 cursor-pointer animate-fade-in"
          onClick={() => // console.log('Agent clicked')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && // console.log('Agent clicked')}
          aria-label="Chat with Agent"
        >
          <div className="relative group">
            <div className="relative w-14 h-14 rounded-full overflow-hidden border-2 border-blue-500 shadow-lg">
              <img
                src="https://www.inquirer.com/resizer/v2/7TRYPKKMOBC3PGFIVHMVICB2II.jpg?auth=b20a0b51258cf3f94f5070a78cfd015b6147df765e883d8bdf6885ad8960a56a&width=700&height=897&smart=true"
                alt="Agent"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            
            <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center animate-pulse">
              !
            </div>
            
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-1 bg-gray-900 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
              FIFA World Cup 26
            </div>
          </div>
        </div>
      )} */}

      {/* Main Content */}
      <Header />
      <TopNavBar />
      
      <div className="w-full overflow-hidden">
        <AutoScrollCarousel />
      </div>
      
      <TopNav />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Betslip Floating Button */}
        {betslipCount > 0 && (
          <BetSlipFloatingButton 
            count={betslipCount}
            onClick={handleNavigateToBetSlip}
          />
        )}

        {/* Live Matches Section */}
        <div className="mb-8">
          <LiveMatches />
        </div>
      </main>

      {/* Promotional Banner */}
      <div className="mb-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="rounded-xl overflow-hidden card-hover">
          <img
            src={image1}
            alt="Special Offer"
            className="w-full h-38 object-cover cursor-pointer transition-transform duration-300 hover:scale-[1.02]"
            loading="lazy"
          />
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6">
        {/* Quick Selection Section */}
        <div className="mb-8">
          <QuickSelection />
        </div>

        {/* Players Banner */}
        <div className="mb-8 rounded-xl overflow-hidden card-hover">
          <img
            src={image2}
            alt="Featured Players"
            className="w-full h-38 object-cover cursor-pointer transition-transform duration-300 hover:scale-[1.02]"
            loading="lazy"
          />
        </div>

        {/* Sport Lists Section */}
        {/* <div className="mb-8">
          <SportLists />
        </div> */}
      </main>
      
      <Footer />
    </div>
  );
};

export default HomePage;